import { FC, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { AdSlotId } from './types';
import { AD_SLOT_CONFIGS } from './config';
import { queueAdSlotRender } from './loadAdLibrary';
import { useAdBreakpoint } from './useAdBreakpoint';

interface AdSlotProps {
  id: AdSlotId;
  className?: string;
}

/**
 * Production ad container. Renders the div the News UK ad library targets by ID.
 * Returns null on breakpoints where the slot is not configured to appear.
 */
export const AdSlot: FC<AdSlotProps> = ({ id, className }) => {
  const config = AD_SLOT_CONFIGS[id];
  const breakpoint = useAdBreakpoint();
  const isVisible = config.visibleOn.includes(breakpoint);

  useEffect(() => {
    if (!isVisible) return;

    queueAdSlotRender(id);
  }, [id, isVisible]);

  if (!isVisible) return null;

  const minHeight = config.minHeight[breakpoint] ?? 250;

  return (
    <div
      id={id}
      className={cn('mx-auto flex w-full justify-center', className)}
      style={{ minHeight }}
    />
  );
};
